import axiosFetch from './config';

export const postRefreshToken = async () => {
  let data =
  {
    refreshToken: localStorage.getItem('refreshToken')
  }
  let response = await axiosFetch({
    method: 'POST',
    data,
    url: '/auth/refreshToken',
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    },
  })
  return response;
};
